import { forwardRef, useRef } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { ButtonColor, ButtonSize, ButtonVariant, getLoadingSpinnerStyles, getButtonStyles } from '../../../utils/buttonStyles.js';
import { getInternalFileInputStyles } from './FileInputStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { Spinner } from '../../Spinner/Spinner.js';
import { SpinnerSize } from '../../Spinner/SpinnerStyles.js';
import { Icon } from '../../Icon/Icon.js';
import { IconSize } from '../../Icon/types/size.js';

const FileInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    disabled = false,
    isFullWidth = false,
    isInactive = false,
    isLoading = false,
    color = ButtonColor.PRIMARY,
    size = ButtonSize.MEDIUM,
    spinner = jsx(Spinner, {
      size: SpinnerSize.SIZE_SMALL
    }),
    variant = ButtonVariant.FILLED,
    onChange,
    name,
    id,
    multiple,
    ...props
  } = _ref;
  const inputRef = useRef(null);
  const Loading = jsx("span", {
    css: getLoadingSpinnerStyles(color, variant),
    children: spinner
  });
  const handleChange = e => {
    onChange && onChange(e);
    if (inputRef.current) {
      // Since we are using this input in a "controlled" way we clean-up on every onChange the internal file data
      // This prevents bugs when trying to upload the same file multiple times
      inputRef.current.value = '';
    }
  };
  return jsxs("label", {
    css: getButtonStyles({
      isFullWidth,
      color,
      size,
      variant,
      isInactive,
      disabled,
      isLoading
    }),
    ref: ref,
    htmlFor: id,
    ...props,
    children: [isLoading && Loading, jsx("input", {
      ref: inputRef,
      type: "file",
      css: getInternalFileInputStyles,
      disabled: disabled,
      onChange: handleChange,
      name: name,
      id: id,
      multiple: multiple
    }), jsx("span", {
      children: children
    }), jsx(Icon, {
      name: IconNames.ATTACH,
      size: IconSize.SIZE_SMALL
    })]
  });
});
FileInput.displayName = 'FileInput';

export { FileInput };
//# sourceMappingURL=FileInput.js.map
